import { IAPproductConfig } from '../../utils/iap/product-config';
import { semaphore, commands } from '../flutter/flutter2-semaphore';
import { premiumSKUs } from './premium-skus';
import { isDev } from "@/utils/debug/is-dev";
import { trialDaysLeft, trialMinutesLeft } from "@/utils/iap/trial-days";
import { invokeFlutterService } from '@/utils/flutter/flutter-service';
import { getProductPrices, getIntroPrice } from './product-price';
import { callSlackWebhook } from "@/utils/webhooks/slack";

const freeComponents = ['photos','calculator'];

/** @type {IAP} */
const IAP = {
    status: [],
    lastUpdated: Date.now(),
    currentProductId: null,
    products: {},
    getIntroPrice: getIntroPrice,
    getProductPrices: getProductPrices,

    getDefaultSku() {
        /*try {
            if (this.getProduct("full_access_2022_monthly")) return "full_access_2022_monthly";
            if (this.getProduct("full_access_monthly_2022")) return "full_access_monthly_2022";
        } catch (e) {
            console.error(e);
        }*/
        return "full_access_monthly_2022";
    },

    getProduct(sku) {
        try {
            if (!('IAP' in window)) {
                captureException(new Error('IAP not found'));
                return null;
            }
            if (!('products' in window.IAP)) {
                callSlackWebhook("#bugreport", "IAP Error - products not found: " + JSON.stringify(window.IAP) , true);
                captureException(new Error('IAP.products not found'));
                return null;
            }
            if (!(sku in window.IAP.products)) {
                callSlackWebhook("#bugreport", "IAP Error - " + sku + " not found: " + JSON.stringify(window.IAP) , true);
                captureException(new Error('IAP.products.sku ' + sku + ' not found'));
                return null;
            }

            return window.IAP.products[sku];
        } catch (error) {
            window.captureException(error);
            return null;
        }
    },
    getProductToUpgrade(id) {
        /** @type {Array<string>} */
        let result = [];

        try {
            const products = IAPproductConfig();

            if (!products.hasOwnProperty(id)) return result;
            if (!products[id].hasOwnProperty('unsubscribe')) return result;

            result = products[id]['unsubscribe'].filter(this.hasAccess);
        } catch(error) {
            captureException(error);
        }

        return result;
    },
    subscribe(id) {
        const { NODE_ENV } = process.env;

        try {
            this.currentProductId = id;

            const data = ['doIt', id];
            const oldSKUList = this.getProductToUpgrade(id);

            if (oldSKUList.length > 0) data.push(oldSKUList[0]);

            if ('SemaphoreJavascriptChannel' in window) {
                semaphore({
                    name: commands.iap.command,
                    data: {
                      value: commands.iap.subscribe,
                      sku: id,
                      oldSku: oldSKUList.length > 0 ? oldSKUList[0] : null,
                    },
                  })
            } else {
                const called = invokeFlutterService('FlutterPaymentService', data.join(':'));

                if (!called) {

                    window.Tracker.logEvent({
                        event_name: 'purchase_failed',
                        event_category: 'iap',
                        event_label: 'FlutterPaymentServiceUnavailable',
                    });

                    app.$bus.$emit('openAppDialog','storeErrorDialog');
                    const params = [
                        "#bugreport",
                        "IAP Error - flutter service could not be called" + JSON.stringify(window.IAP),
                        true,
                    ];
                    callSlackWebhook(...params);
                    // Show error dialog + send to sentry
                } else {
                    window.Tracker.logEvent({
                        event_name: 'purchase_service_called',
                        event_category: 'iap',
                        event_label: 'FlutterPaymentServiceOk'
                    });
                }
            }


            window.Tracker.setUserProperty('subscribe_interested', 1, {
                event_name: 'upgrade',
                event_label: id,
                event_value: 1,
            });
        }
        catch (error) {
            if (NODE_ENV === 'test') throw error;

            captureException(error);

            if(window.packageName === 'com.denticalc.4in1') app.$bus.$emit('subscribe:cancelled');
            else app.$bus.$emit('app.showSnackbar', { text: 'Payment service not available.' });
        }
    },
    unsubscribe(id) {
        try {
            if ('SemaphoreJavascriptChannel' in window) {
                const playUrl = 'https://play.google.com/store/account/subscriptions';
                const appleUrl = 'https://apps.apple.com/account/subscriptions';

                semaphore({
                    name: commands.launchUrl.command,
                    data: {
                        url: window.isAndroid ? playUrl : appleUrl,
                    },
                })
            } else {
                invokeFlutterService('FlutterUnsubscribeService', 'doUnsubscribe');
            }

            window.Tracker.setUserProperty('unsubscribe', 1, {
                event_name: 'unsubscribe',
                event_label: id,
                event_value: 1,
            });
        }
        catch (error) {
            captureException(error);

            if(window.packageName === 'com.denticalc.4in1') app.$bus.$emit('subscribe:cancelled');
            else app.$bus.$emit('app.showSnackbar', { text: 'Payment service not available.' });
        }
    },
    restore() {
        try {
            if ('SemaphoreJavascriptChannel' in window) {
                semaphore({
                    name: commands.iap.command,
                    data: {
                      value: commands.iap.restore,
                    },
                  })
            } else {
                invokeFlutterService('FlutterSubscriptionRestoreService', 'doRestore');
            }

            window.Tracker.logEvent({
                event_name: 'restore_purchase',
                event_category: 'restore_purchase',
                event_label: 'RestorePurchase',
            });
        }
        catch (error) {
            captureException(error);

            if(window.packageName === 'com.denticalc.4in1') app.$bus.$emit('subscribe:cancelled');
            else app.$bus.$emit('app.showSnackbar', { text: 'Payment service not available.' });
        }
    },
    hasPreviousPurchase(id) {
        try {
            if (!('products' in window.IAP)) return false;
            if (!(id in window.IAP.products)) return false;
            if (window.IAP.products[id].hasOwnProperty('purchaseDate') && window.IAP.products[id].purchaseDate !== null && window.IAP.products[id].purchaseDate !== "") return true;
            if (window.IAP.products[id].hasOwnProperty('originalPurchaseDate') && window.IAP.products[id].originalPurchaseDate !== null && window.IAP.products[id].originalPurchaseDate !== "") return true;
            return false;
        } catch (error) {
            window.captureException(error);
            return false;
        }
    },
    hasAccess(id) {
        if (!('products' in window.IAP)) return false;
        if (!(id in window.IAP.products)) return false;
        if (!('subscribed' in window.IAP.products[id])) return false;

        return window.IAP.products[id].subscribed;
    },
    hasAccessAny(ids) {
        for (let i = 0; i<ids.length; i++) {
            if (this.hasAccess(ids[i])) return true;
        }
        return false;
    },
    setAccess(id, status) {
        try {
            window.IAP.products[id].subscribed = status;
        } catch (error) {
            window.captureException(error);
        }
    },
    onSuccess(_) {
        if (this.currentProductId) {
            this.setAccess(this.currentProductId, true);
            this.getProductToUpgrade(this.currentProductId).forEach(id => {
                this.setAccess(id, false);
            });
        }

        window.Tracker.logEvent({
            event_name: 'purchase_succeed',
            event_category: 'purchase_succeed',
            event_label: 'PurchaseSucceed',
        });

        window.Tracker.setUserProperty('successful_subscription', 1, {
            event_name: 'successful_subscription',
            event_label: 'subscribe',
            event_value: window.IAP.currentProductId,
        });

        app.$bus.$emit('closeAppDialogs');
    },
    onError(data) {
        window.Tracker.logEvent({
            event_name: 'purchase_failed',
            event_category: 'iap',
            event_label: 'PurchaseFailed',
        });

        window.Tracker.setUserProperty('abort_subscription', 1, {
            event_name: 'abort_subscription',
            event_label: 'subscribe',
            event_value: window.IAP.currentProductId,
        });

        if (typeof data === 'object' && data !== null && data.hasOwnProperty('errorCode')) {
            window.Tracker.logEvent({
                event_name: 'purchase_error_' + window.IAP.currentProductId,
                event_category: 'iap',
                event_label: data.error,
            });
        }

        const msg = JSON.stringify(data);

        // Ignore user cancel: userCancelled: true
        if (msg.indexOf('userCancelled: true') !== -1) return;

        const params = [
            "#bugreport",
            "IAP Error - purchase failed - " + msg,
            true,
        ];
        callSlackWebhook(...params);

    },
    hasPremiumAccess() {
        return this.hasAccessAny(premiumSKUs);
    },

    hasCouponAccess(id) {
        const data = localStorage.getItem('ca_' + id);
        if (!data) return false;
        return (parseInt(data) > Date.now());
    },

    hasSubscriptionToComponent(componentName) {
        return Object.entries(this.products).some(([key, value]) => {
            if (!this.hasAccess(key) && !this.hasCouponAccess(key)) return false;
            return (value.hasOwnProperty('components')) && (value.components.includes(componentName));
        });
    },

    isValidEmail(email) {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    },

    hasValidEmail() {
        return this.isValidEmail(localStorage.getItem("userEmail"));
    },

    hasAccessToComponent(componentName) {
        if (freeComponents.includes(componentName) && this.hasValidEmail()) return true;
        // if (isDev) return true;
        if (!window.packageName || window.packageName !== 'com.denticalc.4in1') return true;
        if (trialMinutesLeft() > 0) return true;
        if (this.hasSubscriptionToComponent(componentName)) return true;
        return false;
    },
    hasTrialAccess() {
        return (trialMinutesLeft() > 0);
    },
    hasPaidAccess(componentName) {
        if (!window.packageName || window.packageName !== 'com.denticalc.4in1') return true;
        return this.hasSubscriptionToComponent(componentName);
    },
    trialMinutesLeft() {
        console.log(trialMinutesLeft());
    }
};

export { IAP };
